#login {
  align-self: center;
  width: 45em;
  padding: 2em;
  overflow: visible;
  flex-direction: column;
  margin: auto;
}
@media (max-width: 50em) {
  #login {
    margin: 0px;
    width: auto;
    border: none;
    padding: 1rem;
    background: transparent;
  }
}
#login[open] {
  display: flex;
}

#login > .container:has(#name-input:focus-visible) {
  outline: 2px ridge var(--color-accent);
}
#name-input:focus-visible {
  outline: none !important;
}

.logout {
  margin-left: auto;
  display: flex;
  transition: transform 0.4s;
}
.logout svg {
  transition: transform 0.4s;
}
.logout:hover {
  transform: translateX(10px);
}
.logout:hover svg {
  transform: translateX(5px);
}
.logout span {
  font-weight: bold;
  margin-right: 0.5rem;
}

#login > .container {
  margin: 1em 0 0.5em;
  display: flex;
  flex-direction: row;
  background: var(--color-base01);
  border: solid var(--color-base02) var(--border-size);
  border-radius: 10000px;
  overflow: hidden;
}
#login[open] > .container {
  animation: popin 1.3s ease;
}
#login[open] > .logout {
  animation: logout_popin 1s ease;
}

@keyframes logout_popin {
  0% {
    opacity: 0;
    transform: translateX(-100%) scaleX(3);
  }

  30% {
    opacity: 0;
    transform: translateX(-100%) scaleX(3);
  }
  65% {
    opacity: 1;
    transform: translateX(20%) scaleX(0.9);
  }
  100% {
    transform: translateX(0%) scaleX(1);
  }
}

@keyframes popin {
  0% {
    transform: scale(2);
  }
  60% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}

#name-input {
  font-family: inherit;
  font-size: inherit;
  border: none;
  background: transparent;
  color: var(--color-text);
  display: block;
  padding: 0.7rem 1.5rem;
  flex-grow: 10;
  margin: 3px;
  border-radius: 10000px;
  min-width: 0px;
}

#name-input::placeholder {
  color: var(--color-text);
  opacity: 0.7;
}

.ro-name-input {
  color: var(--color-text);
  opacity: 0.7;
  font-weight: bold;

  flex-grow: 1;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
